import { buildColorPropsSDKFactoryCreator } from './colorPropsSDKFactoryBuilder';
import type { IColorSDK } from './colorPropsSDKFactoryBuilder';

export type IStrokeColorSDK = IColorSDK<'strokeColor'>;

export const createStrokeColorPropsSDKFactory =
  buildColorPropsSDKFactoryCreator('strokeColor');
